<template>
    <div class="container">
        <top></top>

        <list></list>

        <div class="major">
            <div class="content">
                <img src="../../assets/img-Lc800/LC-800.jpg" alt="">
            </div>

           <div class="main">
               <div class="Product-information">
                   <h2>
                       <span v-t="'Product_information'"></span>
                   </h2>
                   <div class="Product-information-content">
                       <div class="Product-information-left">
                           <div class="Product-information-left-top">
                               <img src="../../assets/img-Lc800/588x310-01.png" alt="" class="block" v-show="block=='A'">
                               <img src="../../assets/img-Lc800/588x310-02.png" alt="" class="block" v-show="block=='B'">
                               <img src="../../assets/img-Lc800/588x310-03.png" alt="" class="block" v-show="block=='C'">
                               <img src="../../assets/img-Lc800/588x310-04.png" alt="" class="block" v-show="block=='D'">
                           </div>
                           <div class="Product-information-left-bottom">
                               <ul>
                                   <li @click="up('A')" v-bind:class="{'active':(active=='A')}"><img src="../../assets/img-Lc800/135x90-01.png" alt=""></li>
                                   <li @click="up('B')" v-bind:class="{'active':(active=='B')}"><img src="../../assets/img-Lc800/135x90-02.png" alt=""></li>
                                   <li @click="up('C')" v-bind:class="{'active':(active=='C')}"><img src="../../assets/img-Lc800/135x90-03.png" alt=""></li>
                                   <li @click="up('D')" v-bind:class="{'active':(active=='D')}"><img src="../../assets/img-Lc800/135x90-04.png" alt=""></li>
                               </ul>
                           </div>
                       </div>
                       <div class="Product-information-right">
                           <h3><span>LC-800</span></h3>
                           <p v-t="'Lc800_p1'">
                           </p>
                       </div>
                   </div>
               </div>

               <div class="Specifications">
                   <h2>
                       <span v-t="'Parameter_specification'"></span>
                   </h2>
                   <div class="Specifications-main">
                       <table border="1px" cellspacing="0" cellpadding="0">
                           <tr>
                               <th v-t="'img'"></th>
                               <th v-t="'model'"></th>
                               <th v-t="'Interface'"></th>
                               <th v-t="'size'"></th>
                               <th v-t="'Introduction_features'"></th>
                           </tr>
                           <tr>
                               <td>
                                   <img src="../../assets/img-Lc800/160x130.png" alt="">
                               </td>
                               <td>
                                   <h4>LC-800</h4>
                                   <span></span>
                               </td>
                               <td>
                                   <p v-t="'Lc800_Interface_p1'"></p>
                                   <p v-t="'Lc800_Interface_p2'"></p>
                               </td>
                               <td>
                                   <p>160.0 x 80.0 x 31.0</p>
                               </td>
                               <td>
                                   <p v-t="'Lc800_p_word'"></p>
                               </td>
                           </tr>
                       </table>
                   </div>
               </div>

               <div class="Product-performance">
                   <h2>
                       <span v-t="'Product_performance'"></span>
                   </h2>
                   <table border="1px soild" style="width:100%" cellPadding="0" cellSpacing="0">
                       <tr>
                           <th v-t="'Serial_number'"></th>
                           <th v-t="'project'"></th>
                           <th v-t="'describe'"></th>
                       </tr>
                       <tr>
                           <td>1</td>
                           <td rowspan="3" v-t="'td2_1'"></td>
                           <td v-t="'td3_1'"></td>
                       </tr>
                       <tr>
                           <td>2</td>
                           <td v-t="'td3_2'"></td>
                       </tr>
                       <tr>
                           <td>3</td>
                           <td v-t="'td3_3'"></td>
                       </tr>
                       <tr>
                           <td>4</td>
                           <td v-t="'td2_2'"></td>
                           <td v-t="'td3_4'"></td>
                       </tr>
                       <tr>
                           <td>5</td>
                           <td rowspan="2" v-t="'td2_3'"></td>
                           <td v-t="'td3_5'"></td>
                       </tr>
                       <tr>
                           <td>6</td>
                           <td v-t="'td3_6'"></td>
                       </tr>
                       <tr>
                           <td>7</td>
                           <td v-t="'td2_4'"></td>
                           <td v-t="'td3_7'"></td>
                       </tr>
                       <tr>
                           <td>8</td>
                           <td v-t="'td2_5'"></td>
                           <td v-t="'td3_8'"></td>
                       </tr>
                       <tr>
                           <td>9</td>
                           <td v-t="'td2_6'"></td>
                           <td v-t="'td3_8'"></td>
                       </tr>
                       <tr>
                           <td>10</td>
                           <td v-t="'td2_7'"></td>
                           <td v-t="'td3_10'"></td>
                       </tr>
                       <tr>
                           <td>11</td>
                           <td v-t="'td2_8'"></td>
                           <td v-t="'td3_8'"></td>
                       </tr>
                       <tr>
                           <td>12</td>
                           <td v-t="'td2_9'"></td>
                           <td v-t="'td3_12'"></td>
                       </tr>
                       <tr>
                           <td>13</td>
                           <td v-t="'td2_10'"></td>
                           <td v-t="'td3_8'"></td>
                       </tr>
                       <tr>
                           <td>14</td>
                           <td v-t="'td2_11'"></td>
                           <td v-t="'td3_14'"></td>
                       </tr>
                       <tr>
                           <td>15</td>
                           <td rowspan="6" v-t="'td2_12'"></td>
                           <td v-t="'td3_15'"></td>
                       </tr>
                       <tr>
                           <td>16</td>
                           <td v-t="'td3_16'"></td>
                       </tr>
                       <tr>
                           <td>17</td>
                           <td v-t="'td3_17'"></td>
                       </tr>
                       <tr>
                           <td>18</td>
                           <td v-t="'td3_18'"></td>
                       </tr>
                       <tr>
                           <td>19</td>
                           <td v-t="'td3_19'"></td>
                       </tr>
                       <tr>
                           <td>20</td>
                           <td v-t="'td3_20'"></td>
                       </tr>
                       <tr>
                           <td>21</td>
                           <td v-t="'td2_13'"></td>
                           <td v-t="'td3_21'"></td>
                       </tr>
                   </table>
               </div>

               <div class="Detailed-illustration">
                   <h2>
                       <span v-t="'Detailed_illustration'"></span>
                   </h2>
                   <div class="Detailed-illustration-main">
                       <img src="../../assets/img-Lc800/01.jpg" alt="">
                       <img src="../../assets/img-Lc800/02.jpg" alt="">
                       <img src="../../assets/img-Lc800/03.jpg" alt="">
                       <img src="../../assets/img-Lc800/04.jpg" alt="">
                       <img src="../../assets/img-Lc800/05.jpg" alt="">
                       <!-- <img src="../../assets/img-Lc800/06.jpg" alt=""> -->
                   </div>
               </div>
           </div>
        </div>

        <side></side>

        <bottom></bottom>
    </div>
</template>

<script>
    import top from "../../components/common/Head";
    import list from "../../components/common/Nav";
    import side from "../../components/common/Sidebar";
    import bottom from "../../components/common/Foot";

    export default {
        name: "D21",
        components: {
            top,
            list,
            side,
            bottom,
        },
        data(){
            return{
                active: 'A',
                block: 'A',
            }
        },
        methods:{
            up(show) {
                this.active = show;
                this.block = show;
            },
        }
    }
</script>

<style scoped>
    .content img{
        width: 100%;
        height: 100%;
    }
    .Product-information{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Product-information h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Product-information h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Product-information-content{
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
    }
    .Product-information-left{
        display: flex;
        flex-direction: column;
        width: 600px;
    }
    .Product-information-left-top{
        width: 100%;
        height: 310px;
    }
    .Product-information-left-top img{
        width: 100%;
        height: 100%;
    }
    .Product-information-left-bottom{
        margin-top: 15px;
    }
    .Product-information-left-bottom ul{
        display: flex;
        justify-content: space-between;
        margin: 0;
        padding: 0;
    }
    .Product-information-left-bottom ul li{
        width: 135px;
        height: 90px;
        border: 1px solid silver;
    }
    .Product-information-left-bottom ul .active{
        border: 1px solid blue;
    }
    .Product-information-left-bottom ul li img{
        width: 135px;
        height: 90px;
        cursor: pointer;
        display: block;
    }
    .Product-information-right{
        width: 400px;
        margin-left: 20px;
        display: flex;
        flex-direction: column;
    }
    .Product-information-right h3{
        text-align: left;
        font-size: 25px;
        padding-left: 20px;
    }
    .Product-information-right p{
        font-size: 18px;
        padding: 0 20px;
        text-align: left;
        margin-top: 0;
        word-break: break-all;
        word-wrap: break-word;
    }
    .Specifications{
        width: 100%;
        display: flex;
        flex-direction: column;
        margin-top: 20px;
    }
    .Specifications h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Specifications h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Specifications-main{
        width: 1000px;
        margin: 30px auto 0;
    }
    .Specifications-main table{
        border: 1px solid #ddd;
        width: 100%;
    }
    .Specifications-main table tr{
        text-align: center;
    }
    .Specifications-main table tr:first-child{
        background-color: #f9f9f9;
    }
    .Specifications-main table tr th{
        padding: .7rem;
        line-height: 1.6;
        border: 1px solid #ddd;
        font-size: 18px;
    }
    .Specifications-main table tr td{
        padding: 10px;
        width: 20%;
        border: 1px solid #ddd;
    }
    .Specifications-main table tr td img{
        width: 160px;
        height: 130px;
    }
    .Detailed-illustration{
        width: 1000px;
        display: flex;
        padding: 30px 0;
        flex-direction: column;
    }
    .Detailed-illustration h2{
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .Detailed-illustration h2 span{
        border-bottom: 2px solid #c7000b;
        padding-bottom: 10px;
    }
    .Detailed-illustration-main{
        margin: 30px auto 0;
    }
    .Detailed-illustration-main img{
        width: 100%;
        height: 650px;
        display: block;
    }
    .Product-performance{
        margin-top: 60px;
    }
</style>